// extracted by mini-css-extract-plugin
export default {"scrollable":"Dashboard_scrollable__OreK3","scrollable_short":"Dashboard_scrollable_short__kC62G"};